import React from 'react'
import {
    Paper, Box, TextField, Autocomplete, Dialog, DialogActions,
    DialogContent, DialogTitle, Button, Chip, IconButton, Tooltip
} from '@mui/material';
import Swal from 'sweetalert2';
import Loading from '../../Components/Loading/LoadingCenterPage';
import { 
    CheckCircleIcon, 
    TrashIcon, 
    PencilSquareIcon,
    ClipboardDocumentListIcon,
    MagnifyingGlassIcon,
    UserCircleIcon,
    PhoneIcon,
    BriefcaseIcon,
    ClockIcon,
    BuildingOfficeIcon
} from '@heroicons/react/24/outline';

const ReportRegistration = () => {
    const [dataRead, setDataRead] = React.useState(null);
    const [dataReadCheck, setDataReadCheck] = React.useState(null);
    const [dataFilter, setDataFilter] = React.useState(null);
    const [dataFilterCheck, setDataFilterCheck] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [fullWidth] = React.useState(true);
    const [maxWidth] = React.useState('lg');
    const [token] = React.useState(localStorage.getItem("token"));

    if (!token) { window.location = '/Login' }

    if (dataRead?.length === 0) {
        Swal.fire({
            title: "ยังไม่มีข้อมูลผู้สมัครงานรายใหม่",
            icon: 'info',
            confirmButtonText: "ตกลง",
        })
    }

    const handleClickOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleChangePositionJob = (event, newValue) => {
        newValue !== "ทั้งหมด" ? setDataFilter(dataRead?.filter(v => v.positionjob === newValue)) : setDataFilter(dataRead);
    };
    const handleChangeFilterData = (event, newValue) => {
        newValue !== "ทั้งหมด" ? setDataFilter(dataRead?.filter(v => v.req_company === newValue)) : setDataFilter(dataRead);
    };

    const date = (value) => {
        return new Date(value).toLocaleString('th-TH', {
            day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
        })
    }

    const handleChangePositionJob_check = (event, newValue) => {
        newValue !== "ทั้งหมด" ? setDataFilterCheck(dataReadCheck?.filter(v => v.positionjob === newValue)) : setDataFilterCheck(dataReadCheck);
    };
    const handleChangeFilterData_check = (event, newValue) => {
        newValue !== "ทั้งหมด" ? setDataFilterCheck(dataReadCheck?.filter(v => v.req_company === newValue)) : setDataFilterCheck(dataReadCheck);
    };

    const getDataRead = async () => {
        fetch('https://script.google.com/macros/s/AKfycbxvOi1y2SpMqRssJhpa2dKgzd_k9reXEoNCtW0i086kSGQDq5nchndK7HioiJAo4xit3A/exec', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({ action: "read" })
        })
        .then(response => response.json())
        .then((res) => {
            setDataRead(res.data.filter(v => v.check !== "yes"));
            setDataReadCheck(res.data.filter(v => v.check === "yes"))
        })
        .catch(error => console.error('Error!', error.message));
    }

    React.useEffect(() => {
        if (dataRead === null) getDataRead();
    }, [dataRead]);

    const handleCheck = (data) => {
        const form = document.getElementById('form-remark' + data.id)
        const formData = new FormData(form);
        if (formData.get("remark") === "") {
            Swal.fire({ title: "ไม่ได้ระบุหมายเหตุ", icon: 'error' });
            return;
        }
        Swal.fire({
            title: "ยืนยันบันทึก", icon: 'warning', showDenyButton: true, confirmButtonText: "ตกลง", denyButtonText: `ยกเลิก`
        }).then((result) => {
            if (result.isConfirmed) {
                fetch('https://script.google.com/macros/s/AKfycbxvOi1y2SpMqRssJhpa2dKgzd_k9reXEoNCtW0i086kSGQDq5nchndK7HioiJAo4xit3A/exec', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams({ check: "yes", remark: formData.get("remark"), action: "update", id: data?.id })
                }).then(() => {
                    Swal.fire({ title: 'บันทึกข้อมูลสำเร็จ!!', icon: 'success' }).then(() => getDataRead());
                });
            }
        });
    }

    const handleDelete = (data) => {
        Swal.fire({
            title: "ยืนยันลบ", icon: 'warning', showDenyButton: true, confirmButtonText: "ตกลง"
        }).then((result) => {
            if (result.isConfirmed) {
                fetch('https://script.google.com/macros/s/AKfycbxvOi1y2SpMqRssJhpa2dKgzd_k9reXEoNCtW0i086kSGQDq5nchndK7HioiJAo4xit3A/exec', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams({ action: "delete", id: data?.id })
                }).then(() => {
                    Swal.fire({ title: 'ลบสำเร็จ!!', icon: 'success' }).then(() => getDataRead());
                });
            }
        });
    }

    const handleUpdateRemark = (data) => {
        Swal.fire({
            input: 'text', icon: 'info', title: 'หมายเหตุใหม่', inputValue: data?.remark, showDenyButton: true
        }).then((a) => {
            if (a.isConfirmed) {
                fetch('https://script.google.com/macros/s/AKfycbxvOi1y2SpMqRssJhpa2dKgzd_k9reXEoNCtW0i086kSGQDq5nchndK7HioiJAo4xit3A/exec', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams({ remark: a.value, action: "update", id: data?.id })
                }).then(() => {
                    Swal.fire({ title: 'บันทึกข้อมูลสำเร็จ!!', icon: 'success' }).then(() => getDataRead());
                });
            }
        })
    }

    const positionJob_nonCheck = React.useMemo(() => ["ทั้งหมด", ...new Set(dataRead?.map(v => v.positionjob))], [dataRead]);
    const hospital = React.useMemo(() => ["ทั้งหมด", ...new Set(dataRead?.map(v => v.req_company))], [dataRead]);
    const positionJob_Check = React.useMemo(() => ["ทั้งหมด", ...new Set(dataReadCheck?.map(v => v.positionjob))], [dataReadCheck]);
    const hospital_Check = React.useMemo(() => ["ทั้งหมด", ...new Set(dataReadCheck?.map(v => v.req_company))], [dataReadCheck]);

    return (
        <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: '#F8FAFC', minHeight: '100vh' }}>
            {dataRead !== null ? (
                <Box sx={{ maxWidth: 1600, mx: 'auto' }}>
                    
                    {/* Header Section */}
                    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', md: 'center' }, mb: 4, gap: 2 }}>
                        <Box>
                            <h1 style={{ fontSize: '1.875rem', fontWeight: 900, color: '#1E293B', margin: 0 }}>รายงานข้อมูลการลงทะเบียนสมัครงาน</h1>
                            <p style={{ color: '#64748B', fontWeight: 500, marginTop: 4 }}>ระบบคัดกรองและจัดการบุคลากรเบื้องต้น</p>
                        </Box>
                        <Button 
                            onClick={handleClickOpen} 
                            variant="contained" 
                            startIcon={<CheckCircleIcon style={{ width: 20 }} />}
                            sx={{ borderRadius: 3, px: 3, py: 1.5, bgcolor: '#4F46E5', textTransform: 'none', fontWeight: 700, boxShadow: '0 4px 12px rgba(79, 70, 229, 0.3)' }}
                        >
                            รายการที่ติดต่อกลับแล้ว
                        </Button>
                    </Box>

                    {/* Filter Section */}
                    <Paper sx={{ p: 3, mb: 4, borderRadius: 4, display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#64748B', mr: 2 }}>
                            <MagnifyingGlassIcon style={{ width: 20 }} />
                            <span style={{ fontSize: 14, fontWeight: 700 }}>ตัวกรองข้อมูล:</span>
                        </Box>
                        <Autocomplete
                            options={positionJob_nonCheck}
                            sx={{ width: 280 }}
                            size="small"
                            onChange={handleChangePositionJob}
                            renderInput={(params) => <TextField {...params} label="ตำแหน่งงาน" variant="outlined" />}
                        />
                        <Autocomplete
                            options={hospital}
                            sx={{ width: 280 }}
                            size="small"
                            onChange={handleChangeFilterData}
                            renderInput={(params) => <TextField {...params} label="สถานพยาบาล" variant="outlined" />}
                        />
                    </Paper>

                    {/* Cards Grid */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        {(dataFilter === null || dataFilter.length === 0 ? dataRead : dataFilter).map((v, i) => (
                            <div key={i} className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
                                {/* Header */}
                                <div className="flex items-start justify-between mb-4">
                                    <div className="flex items-center gap-3">
                                        <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg">
                                            {v.name.charAt(0)}
                                        </div>
                                        <div>
                                            <h3 className="text-lg font-bold text-gray-900">{v.name}</h3>
                                            <div className="flex items-center gap-2 mt-1">
                                                <Chip 
                                                    label={`ชื่อเล่น: ${v.nikname}`}
                                                    size="small"
                                                    sx={{ bgcolor: '#F3E8FF', color: '#6B21A8', fontWeight: 600, fontSize: 11 }}
                                                />
                                                <Chip 
                                                    label={`${v.age} ปี`}
                                                    size="small"
                                                    color={v.age > 40 ? "error" : "default"}
                                                    sx={{ fontWeight: 700, fontSize: 11 }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-2 text-xs text-gray-500">
                                        <ClockIcon className="h-4 w-4" />
                                        <span>{date(v.timestamp)}</span>
                                    </div>
                                </div>

                                {/* Info Grid */}
                                <div className="space-y-3 mb-4">
                                    <div className="flex items-start gap-2">
                                        <BriefcaseIcon className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5" />
                                        <div className="flex-1">
                                            <p className="text-xs text-gray-500 font-semibold uppercase">ตำแหน่งที่สมัคร</p>
                                            <p className="text-sm font-bold text-gray-900 mt-0.5">{v.positionjob}</p>
                                        </div>
                                    </div>

                                    <div className="flex items-start gap-2">
                                        <PhoneIcon className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                                        <div className="flex-1">
                                            <p className="text-xs text-gray-500 font-semibold uppercase">เบอร์โทรติดต่อ</p>
                                            <p className="text-sm font-mono font-bold text-gray-900 mt-0.5">{v.phone}</p>
                                        </div>
                                    </div>

                                    <div className="flex items-start gap-2">
                                        <BuildingOfficeIcon className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
                                        <div className="flex-1">
                                            <p className="text-xs text-gray-500 font-semibold uppercase">สถานที่ทำงานเดิม</p>
                                            <p className="text-sm text-gray-700 mt-0.5">{v.old_company}</p>
                                        </div>
                                    </div>

                                    <div className="flex items-start gap-2">
                                        <BuildingOfficeIcon className="h-5 w-5 text-purple-600 flex-shrink-0 mt-0.5" />
                                        <div className="flex-1">
                                            <p className="text-xs text-gray-500 font-semibold uppercase">ต้องการทำงานที่</p>
                                            <p className="text-sm font-semibold text-gray-900 mt-0.5">{v.req_company}</p>
                                        </div>
                                    </div>

                                    <div className="pt-2">
                                        <Chip 
                                            label={`ประสบการณ์: ${v.experience}`}
                                            variant="outlined"
                                            size="small"
                                            sx={{ 
                                                fontWeight: 700, 
                                                borderColor: v.experience === 'มี' ? '#10B981' : '#E2E8F0', 
                                                color: v.experience === 'มี' ? '#059669' : '#94A3B8',
                                                fontSize: 11
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Remark & Actions */}
                                <div className="border-t border-gray-100 pt-4">
                                    {v.remark === "" ? (
                                        <Box id={'form-remark' + v.id} component="form" sx={{ mb: 2 }}>
                                            <TextField 
                                                required 
                                                name='remark' 
                                                placeholder="เพิ่มหมายเหตุ..." 
                                                variant="outlined" 
                                                size="small"
                                                fullWidth
                                                sx={{ fontSize: 13 }}
                                            />
                                        </Box>
                                    ) : (
                                        <div className="mb-3 p-2 bg-amber-50 rounded-lg border border-amber-200">
                                            <p className="text-xs text-amber-600 font-semibold uppercase mb-1">หมายเหตุ</p>
                                            <p className="text-sm text-amber-900 font-medium italic">{v.remark}</p>
                                        </div>
                                    )}
                                    
                                    <div className="flex gap-2">
                                        <Tooltip title="ติดต่อแล้ว">
                                            <button
                                                onClick={() => handleCheck(v)}
                                                className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 bg-green-50 hover:bg-green-100 text-green-700 font-semibold rounded-xl transition-colors"
                                            >
                                                <CheckCircleIcon className="h-5 w-5" />
                                                ติดต่อแล้ว
                                            </button>
                                        </Tooltip>
                                        <Tooltip title="ลบ">
                                            <IconButton 
                                                onClick={() => handleDelete(v)}
                                                sx={{ bgcolor: '#FEF2F2', '&:hover': { bgcolor: '#FEE2E2' } }}
                                            >
                                                <TrashIcon className="h-5 w-5 text-red-600" />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Dialog: Contacted List */}
                    <Dialog fullWidth open={open} onClose={handleClose} maxWidth="xl" disableEnforceFocus PaperProps={{ sx: { borderRadius: 5, p: 2 } }}>
                        <DialogTitle sx={{ fontWeight: 900, fontSize: '1.5rem', pb: 0 }}>
                            รายการที่ติดต่อกลับเรียบร้อย
                        </DialogTitle>
                        <DialogContent>
                            <Box sx={{ display: "flex", gap: 2, my: 3 }}>
                                <Autocomplete
                                    options={positionJob_Check}
                                    sx={{ width: 250 }}
                                    size="small"
                                    onChange={handleChangePositionJob_check}
                                    renderInput={(params) => <TextField {...params} label="กรองตำแหน่ง" />}
                                />
                                <Autocomplete
                                    options={hospital_Check}
                                    sx={{ width: 250 }}
                                    size="small"
                                    onChange={handleChangeFilterData_check}
                                    renderInput={(params) => <TextField {...params} label="กรองสถานพยาบาล" />}
                                />
                            </Box>
                            
                            {/* Cards Grid for Contacted */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-h-[500px] overflow-y-auto pr-2">
                                {(dataFilterCheck === null || dataFilterCheck.length === 0 ? dataReadCheck : dataFilterCheck).map((v, i) => (
                                    <div key={i} className="bg-gray-50 rounded-xl p-4 border border-gray-200">
                                        <div className="flex items-start justify-between mb-3">
                                            <div>
                                                <h4 className="font-bold text-gray-900">{v.name}</h4>
                                                <p className="text-xs text-gray-500 mt-1">{date(v.timestamp)}</p>
                                            </div>
                                            <Chip label={`${v.age} ปี`} size="small" sx={{ fontWeight: 700, fontSize: 10 }} />
                                        </div>
                                        <div className="space-y-2 text-sm">
                                            <p><span className="text-gray-500">ตำแหน่ง:</span> <span className="font-semibold">{v.positionjob}</span></p>
                                            <p><span className="text-gray-500">เบอร์:</span> <span className="font-mono font-semibold">{v.phone}</span></p>
                                            <p><span className="text-gray-500">สถานที่เดิม:</span> {v.old_company}</p>
                                            <p><span className="text-gray-500">ต้องการ:</span> <span className="font-semibold">{v.req_company}</span></p>
                                            <div className="flex items-center justify-between pt-2 border-t border-gray-200">
                                                <Chip label={v.experience} size="small" sx={{ fontSize: 10 }} />
                                                <div className="flex items-center gap-1">
                                                    <span className="text-xs text-green-600 font-semibold">{v.remark || "-"}</span>
                                                    <IconButton onClick={() => handleUpdateRemark(v)} size="small">
                                                        <PencilSquareIcon style={{ width: 14, color: '#64748B' }} />
                                                    </IconButton>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </DialogContent>
                        <DialogActions sx={{ p: 3 }}>
                            <Button onClick={handleClose} sx={{ color: '#64748B', fontWeight: 700 }}>ปิดหน้าต่าง</Button>
                        </DialogActions>
                    </Dialog>
                </Box>
            ) : <Loading />}
        </Box>
    );
}

export default ReportRegistration;
